// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__4oOth","itemTitle":"ClientEmergencyInfo_itemTitle__1FyTj","itemText":"ClientEmergencyInfo_itemText__2F0js"};